/* assets/vc-lace.js — <vc-lace>: the lace rule embroiders itself as it scrolls into view (spec §8.3, D14;
 * task-11-brief.md). Markup and the draw itself: snippets/vc-lace-divider.liquid.
 *
 * Ported from the divider part of prototypes/lace.html:
 * - an IntersectionObserver at threshold .6 adds .is-drawn once, when 60% of the rule is in view, then lets it go
 *   (:887-891);
 * - reduced motion: drawn at once (:875) — the snippet's undrawn state only exists under
 *   prefers-reduced-motion: no-preference, so this is belt and braces;
 * - no IntersectionObserver: drawn at once (:892).
 * The prototype's rAF loop (drawDiv, :851-861) moved the thread's mask edge linearly in easeCine(t); a CSS transition
 * on cubic-bezier(.2,.7,.1,1) is that same curve (https://www.w3.org/TR/css-easing-1/#cubic-bezier-easing-functions,
 * the definition the prototype's bezier() solves), so the snippet's CSS carries the whole draw and this module only
 * decides when.
 * A custom element: a section the theme editor re-renders is picked up by connectedCallback
 * (https://developer.mozilla.org/en-US/docs/Web/API/Web_components/Using_custom_elements).
 */
const THRESHOLD = 0.6; // prototypes/lace.html:890

const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

let io = null;
function observer() {
  if (!io && 'IntersectionObserver' in window) {
    io = new IntersectionObserver((entries) => {
      for (const en of entries) {
        if (!en.isIntersecting) continue;
        en.target.classList.add('is-drawn');
        io.unobserve(en.target);
      }
    }, { threshold: THRESHOLD });
  }
  return io;
}

export class VcLace extends HTMLElement {
  connectedCallback() {
    if (this.classList.contains('is-drawn')) return;
    const o = reducedMotion() ? null : observer();
    if (o) o.observe(this);
    else this.classList.add('is-drawn');
  }

  disconnectedCallback() {
    if (io) io.unobserve(this);
  }
}

if (!customElements.get('vc-lace')) customElements.define('vc-lace', VcLace);
